import { isIOS } from 'react-device-detect';

export const isInstalled = 'standalone' in navigator && navigator['standalone'];

const ua = window.navigator.userAgent;
export const isWebKit = !!ua.match(/WebKit/i);
export const isCriOS = !!ua.match(/CriOS/i);
export const isIOSSafari = isIOS && isWebKit && !isCriOS;
